import { render } from "./IconSuccess.vue?vue&type=template&id=51a95a1d"
import script from "./IconSuccess.vue?vue&type=script&lang=js"
export * from "./IconSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconSuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51a95a1d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51a95a1d', __exports__)) {
    api.reload('51a95a1d', __exports__)
  }
  
  module.hot.accept("./IconSuccess.vue?vue&type=template&id=51a95a1d", () => {
    api.rerender('51a95a1d', render)
  })

}


export default __exports__